<script setup>
import {onMounted, ref} from "vue";
import http from "@/http";
import {ElMessage} from "element-plus";
import {useRoute, useRouter} from "vue-router";

const router = useRouter();
const route = useRoute();
const loading = ref(false);
const regionLoading = ref(false);
const districtLoading = ref(false);
const quarterLoading = ref(false);
const form = ref({
  id: null,
  owner: null,
  address: null,
  area: null,
  region_id: null,
  district_id: null,
  quarter_id: null,
  board_id: null,
  location: null,
});

const boards = ref([]);
const regions = ref([]);
const quarters = ref([]);
const districts = ref([]);
const formRef = ref();

const rules = {
  owner: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
  address: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
  area: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
  region_id: [
    {required: true, message: "Majburiy maydon", trigger: "change"},
  ],
  district_id: [
    {required: true, message: "Majburiy maydon", trigger: "change"},
  ],
  quarter_id: [
    {required: true, message: "Majburiy maydon", trigger: "change"},
  ],
  board_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
  location: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
};

const getBoards = () => {
  loading.value = true;
  http({url: `api/v1/boards`, params: {status: 1, type: 'MY_GARDEN'}})
      .then(({data}) => {
        boards.value = data.boards;
      })
      .catch((err) => {
        ElMessage.error(
            err.response.data.message || `Hatolik qayta urinib ko'ring`
        );
      })
      .finally(() => {
        loading.value = false;
      });
};
const onChangeRegion = () => {
  getDistricts();
};

const onChangeDistrict = () => {
  getQuarters();
};

const getRegions = () => {
  regionLoading.value = true;
  http({url: "/api/v1/regions"})
      .then(({data}) => {
        regions.value = data.regions;
      })
      .catch(() => {
        ElMessage.error(`Viloyatlar yuklanmadi. Qayta urinib ko'ring`);
      })
      .finally(() => {
        regionLoading.value = false;
      });
};
const getDistricts = () => {
  districtLoading.value = true;
  http({url: `/api/v1/districts?region_id=${form.value.region_id}`})
      .then(({data}) => {
        districts.value = data.districts;
      })
      .catch(() => {
        ElMessage.error(`Tumanlar yuklanmadi. Qayta urinib ko'ring`);
      })
      .finally(() => {
        districtLoading.value = false;
      });
};

const getQuarters = () => {
  quarterLoading.value = true;
  http({url: `/api/v1/quarters?district_id=${form.value.district_id}`})
      .then(({data}) => {
        quarters.value = data.quarters;
      })
      .catch(() => {
        ElMessage.error(`Mahalla yuklanmadi. Qayta urinib ko'ring`);
      })
      .finally(() => {
        quarterLoading.value = false;
      });
};
const getGardenPlaceById = () => {
  loading.value = true;
  http({url: `api/v1/garden-places/${form.value.id}`})
      .then(({data}) => {
        form.value = data;
        if (form.value.region_id) {
          getDistricts();
        }
        if (form.value.district_id) {
          getQuarters();
        }
      })
      .catch((err) => {
        ElMessage.error(
            err.response.data.message || `Hatolik qayta urinib ko'ring`
        );
      })
      .finally(() => {
        loading.value = false;
      });
};

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid) => {
    if (valid) {
      loading.value = true;
      http({
        url: `api/v1/garden-places${form.value.id ? `/${form.value.id}` : ""}`,
        data: form.value,
        method: form.value.id ? "put" : "post",
      })
          .then(() => {
            router.go(-1);
          })
          .catch((err) => {
            ElMessage.error(
                err.response.data.message || `Hatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            loading.value = false;
          });
    }
  });
};

onMounted(() => {
  if (route.params.id) {
    form.value.id = route.params.id;
    getGardenPlaceById();
  }
  getBoards();
  getRegions();
});
</script>

<template>
  <p style="font-size: 18px" class="pb-8">
    {{ form.id ? "Taxrirlash" : `Qo'shish` }}
  </p>
  <el-row class="add-news">
    <el-col :xs="24" :sm="18" :md="12" :lg="12" :xl="8">
      <el-form
          label-position="top"
          v-loading="loading"
          ref="formRef"
          :rules="rules"
          :model="form"
      >
        <el-form-item label="Egalik qiluvchi" prop="owner">
          <el-input v-model="form.owner" type="text"/>
        </el-form-item>
        <el-form-item label="Boardni tanlang" prop="board_id">
          <el-select v-model="form.board_id" style="width: 100%">
            <el-option
                v-for="board in boards"
                :key="board.id"
                :value="board.id"
                :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil'
              "
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Viloyatni tanlang" prop="region_id">
          <el-select
              style="width: 100%"
              v-loading="regionLoading"
              v-model="form.region_id"
              @change="onChangeRegion"
              size="large"
              placeholder="Viloyat"
          >
            <el-option
                v-for="region in regions"
                :value="region.id"
                :label="region.title"
                :key="region.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Tumanni tanlang" prop="district_id">
          <el-select
              style="width: 100%"
              v-loading="districtLoading"
              v-model="form.district_id"
              size="large"
              @change="onChangeDistrict"
              placeholder="Tuman"
          >
            <el-option
                v-for="district in districts"
                :value="district.id"
                :label="district.title"
                :key="district.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Mahallani tanlang" prop="quarter_id">
          <el-select
              style="width: 100%"
              v-loading="quarterLoading"
              v-model="form.quarter_id"
              size="large"
              placeholder="Mahallani tanlang"
          >
            <el-option
                v-for="quarter in quarters"
                :value="quarter.id"
                :label="quarter.title"
                :key="quarter.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Manzil" prop="address">
          <el-input v-model="form.address" type="text"/>
        </el-form-item>
        <el-form-item label="Maydon" prop="area">
          <el-input-number
              style="width: 100%"
              v-model="form.area"
              type="number"
          />
        </el-form-item>
        <el-form-item label="Lakatsiya" prop="location">
          <el-input v-model="form.location" type="text"/>
        </el-form-item>
        <div class="mt-15 text-right">
          <el-button
              @click="$router.go(-1)"
              class="el-button el-button--danger"
          >
            Bekor qilish
          </el-button>
          <el-button type="primary" @click="submitForm(formRef)"
          >Saqlash
          </el-button>
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<style scoped lang="scss">
.text-right {
  text-align: right;
}

a {
  text-decoration: none;
}
</style>
